
define('ldsh!modules/lp_info/templates/variant_chart', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="ed-stats-tabs ' +
((__t = ( hideTabs ? 'hidden' : '' )) == null ? '' : __t) +
'">\n  <div class="stats-tab chart-selection is-active" data-tab="history" data-i18n="landingPage.chart.chart">GrÃ¡fica</div>\n  <div class="stats-tab funnel-selection" data-tab="funnel">\n    <select class="js-select">\n      ';
 _.each(funnelOptions, function (item) { ;
__p += '\n        <option value="' +
((__t = ( item.key )) == null ? '' : __t) +
'">' +
((__t = ( item.value )) == null ? '' : __t) +
'</option>\n      ';
 }, this); ;
__p += '\n    </select>\n  </div>\n</div>\n\n<div class="js-chart ed-highchart-container" style="height: 464px"></div>\n';

}
return __p
};});

